import { StatePanel } from "@/ds/custom/StatePanel";
import { Button } from "@/ds/shadcn/components/ui/button";
import { CrownIcon } from "lucide-react";
import type { FC } from "react";
import { Link } from "react-router";

export interface PremiumRequiredProps {
	featureName: string;
	compact?: boolean;
}

export const PremiumRequired: FC<PremiumRequiredProps> = props => {
	const {
		featureName,
		compact = false
	} = props;

	return (
		<StatePanel
			icon={CrownIcon}
			title={`${featureName} is for Premium Users`}
			description={compact ? undefined : `Become a Premium User now and access ${featureName} plus heaps of other features!`}
			compact={compact}>
			<Button size={compact ? "sm" : "default"} asChild>
				<Link to="/settings/subscription">Subscribe Now</Link>
			</Button>
		</StatePanel>
	);
};
